<!--
 ECHARTS 的 饼图
-->
<template>
  <!-- 250px -->
  <div :id="comID" :style="pieStyle"></div>
</template>

<script>
  // 按需引入
  import 'echarts/lib/component/tooltip';
  import 'echarts/lib/component/legend';
  import 'echarts/lib/component/grid';

  import * as echarts from 'echarts/lib/echarts';
  import {
    GridComponent
  } from 'echarts/components';
  echarts.use([GridComponent]);

  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  export default {
    props: {
      // ID
      comID: {
        type: String,
        default: 'myChart_bar'
      },
      // 高度
      comHeight: {
        type: Number,
        default: 600
      },
      // 数据
      comxAxisData: {
        type: Array,
        default: () => {
          return [];
        }
      },
      // 数据
      comSeries: {
        type: Array,
        default: () => {
          return [];
        }
      },
    },
    data() {
      return {
        // 用于计算高度
        pieStyle: '',
        xAxisData: [],
        series: []
      };
    },
    created() {
      let that = this;
      that.xAxisData = that.comxAxisData;
      that.series = that.comSeries;

      that.$nextTick(() => {
        that.drawLine();
      });
      that.pieStyle = 'width: 100%; height:' + (that.comHeight * 0.0625) + 'rem;';
    },
    watch: {
      comxAxisData() {
        let that = this;
        that.xAxisData = that.comxAxisData;
        that.$nextTick(() => {
          that.drawLine();
        })
      },
      comSeries() {
        let that = this;
        that.series = that.comSeries;
        that.$nextTick(() => {
          that.drawLine();
        });
      }
    },
    mounted() {
      let that = this;
      window.onresize = function() {
        // that.myChart.resize();
        that.pieStyle = 'width: 100%; height:' + (that.comHeight * 0.0625) + 'rem;';
      }
    },
    methods: {

      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById(this.comID));


        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: '5%',
            left: '0%',
            right: '0%',
            bottom: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: this.xAxisData,
            axisLabel: { interval: 0, rotate: 50 },
          },
          yAxis: {
            type: 'value'
          },
          series: this.series,
        });
      }
    }
  };
</script>

<style>

</style>
